import { useDashboard } from '@/modules/dashboard/stores/dashboardStore'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'

export const deleteWidget = async (widgetId: number) => {
  const dashboardStore = useDashboard()
  const feedbackStore = useFeedbackStore()

  const isWidgetSuccessfullyDeleted = await dashboardStore.deleteMyWidget(widgetId)
  if (isWidgetSuccessfullyDeleted) {
    feedbackStore.showToast({ type: 'success', message: 'Виджет успешно удален' })
    await dashboardStore.fetchMyWidgets()
  }
}
